// authStore.js
import { reactive } from 'vue';
import axios from 'axios';

export const authStore = reactive({
  isLoggedIn: false,
  user: null,
  // 全局唯一登录弹窗状态，废弃组件内局部showLogin
  showLoginModal: false,
  
  login(userData) {
    this.isLoggedIn = true;
    this.user = userData;
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('isLoggedIn', 'true');
    this.showLoginModal = false;
  },
  
  logout() {
    this.isLoggedIn = false;
    this.user = null;
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('username');
    localStorage.removeItem('token_expiry');
  },
  
  async refreshToken() {
    const refresh = localStorage.getItem('refresh');
    if (!refresh) {
      this.logout();
      return false;
    }

    try {
      const response = await axios.post('/api/membership/jwt/refresh/', { refresh });
      const { access } = response.data;
      localStorage.setItem('token', access);
      this.isLoggedIn = true;

      const expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 24);
      localStorage.setItem('token_expiry', expiryDate.toISOString());

      const savedUser = localStorage.getItem('user');
      if (savedUser) this.user = JSON.parse(savedUser);

      return true;
    } catch (error) {
      console.error('JWT Token Refresh failed:', error);
      this.logout();
      return false;
    }
  },

  // 统一打开登录弹窗
  openLoginModal() {
    this.showLoginModal = true;
  },
  // 统一关闭登录弹窗
  closeLoginModal() {
    this.showLoginModal = false;
  },
  
  async init() {
    const savedStatus = localStorage.getItem('isLoggedIn');
    const hasToken = localStorage.getItem('token');
    const hasRefresh = localStorage.getItem('refresh');

    if (savedStatus === 'true' && hasToken) {
      const savedUser = localStorage.getItem('user');
      try {
        if (savedUser) this.user = JSON.parse(savedUser);
        this.isLoggedIn = true;
      } catch (e) {
        this.logout();
      }
    } else if (hasRefresh) {
      await this.refreshToken();
    }
  }
});